import { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import api from '../../../../services/api';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import HeaderSession from '../../../../utils/headerSession';
import { Paper, Typography } from '@mui/material';
import RegisterAccess from '../../../../utils/registerAccess';
import ListaVazia from '../../../../utils/listaVazia';
import Date from '../../../../utils/date';
import FerramentaNavegacaoExportacao from '../../../../utils/paginacao';
import TempoPassado from '../../../../utils/tempoPassado';
import TabelaLoading from '../../../../load/tabelaLoading';


const useStyles = () => ({
  hover: { '&:hover': { backgroundColor: '#85287d8a' }, cursor: 'pointer' },
});

const ListaSolicitacoesDesalfandegamento = ({ importadorId }) => {
  const classes = useStyles();
  const { status } = useParams()
  const [solicitacoes, setSolicitacoes] = useState('');
  // const [status, setStatus] = useState('Análise');
  const [configLista, setConfigLista] = useState('');
  const [searchParams] = useSearchParams();
  const [page, setPage] = useState(searchParams.get("page"));
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    api.get(`/declaracao-desalfandegamentos?status=${status ?? ''}&page=${page}&importadorId=${importadorId ?? ''}`)
      .then(response => {
        // console.log(response)
        setSolicitacoes(response.data.declaracaoDesalfandegamentos)
        setConfigLista(response.data)

        localStorage.setItem('urlAnterior', location.pathname + location.search); 
      }).catch(err => {
        // console.log(err)
      })
  }, [status, page])


  // const filtraReclamacoes = (valor) => {
  //   setSolicitacoes(filter.filter((espedienteGeral) => (espedienteGeral?.nome?.toLowerCase().includes(valor.toLowerCase()))))
  // }

  return (

    <>
      {!importadorId &&
        <>
          <RegisterAccess page={'lista de solicitações de desalfandegamento'} />
          <HeaderSession title={'SOLICITAÇÕES DE DESALFANDEGAMENTO'} />
        </>
      }

      {solicitacoes ? solicitacoes.length > 0 ?

        <TableContainer sx={{ border: "1px black" }} component={Paper}>
          <Table sx={{ border: "1px", borderColor: "black" }}>
            <TableHead sx={{ backgroundColor: "#dcdede" }}>
              <TableRow>
                <TableCell align="center" ><Typography noWrap> <strong> Importador </strong></Typography></TableCell>
                <TableCell align="center" ><Typography noWrap> <strong> Nº de Declaração </strong></Typography></TableCell>
                <TableCell align="center" ><Typography noWrap> <strong> Ponto de Entrada </strong></Typography></TableCell>
                <TableCell align="center" ><Typography noWrap> <strong> Destino </strong></Typography></TableCell>
                <TableCell align="center" ><Typography noWrap> <strong> Estado </strong></Typography></TableCell>
                <TableCell align="center" ><Typography noWrap> <strong> Data </strong></Typography></TableCell>
                <TableCell ><Typography noWrap> <strong>Ultima intervenção</strong></Typography></TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {solicitacoes.map((solicitacao) => (
                <TableRow key={solicitacao._id} style={classes.hover} onClick={() => { navigate(`/admin/dmts/gest/solicitacao-de-desalfandegamento/${solicitacao?.solicitacaoImportacaoId}`) }}>
                  <TableCell ><Typography noWrap> {solicitacao.importador?.nome}</Typography></TableCell>
                  <TableCell  ><Typography > {solicitacao.numeroDeclaracao}</Typography></TableCell>
                  <TableCell  ><Typography > {solicitacao.pontoEntrada}</Typography></TableCell>
                  <TableCell  ><Typography noWrap> {solicitacao.destino}</Typography></TableCell>
                  <TableCell align="center" ><Typography noWrap> {solicitacao?.status} </Typography></TableCell>
                  <TableCell align="center" ><Typography noWrap> <Date date={solicitacao?.createdAt} /> </Typography></TableCell>
                  <TableCell ><TempoPassado date={solicitacao.updatedAt} /> </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

          <FerramentaNavegacaoExportacao
            configLista={configLista}
            lista={solicitacoes}
            page={page}
            setPage={setPage}
          />
        </TableContainer>
        :
        <ListaVazia />
        :
        <TabelaLoading text={'A carregar solicitações'} />
      }
    </>
  )
}

export default ListaSolicitacoesDesalfandegamento 
